var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutZone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#BA1A1A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_383_736",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_383_736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66669 17.9997L12 5.33301L19.3334 17.9997H4.66669ZM11.3334 13.9997H12.6667V10.6663H11.3334V13.9997ZM12 15.9997C12.1889 15.9997 12.3474 15.9357 12.4754 15.8077C12.6029 15.6801 12.6667 15.5219 12.6667 15.333C12.6667 15.1441 12.6029 14.9859 12.4754 14.8583C12.3474 14.7303 12.1889 14.6663 12 14.6663C11.8111 14.6663 11.6529 14.7303 11.5254 14.8583C11.3974 14.9859 11.3334 15.1441 11.3334 15.333C11.3334 15.5219 11.3974 15.6801 11.5254 15.8077C11.6529 15.9357 11.8111 15.9997 12 15.9997ZM6.96669 16.6663H17.0334L12 7.99967L6.96669 16.6663Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutZone);
export default __webpack_public_path__ + "static/media/out_zone.75351a9ad8709530adf42c509c8a12fa.svg";
export { ForwardRef as ReactComponent };